import React from 'react';
// material-ui components
import { makeStyles } from "@mui/styles";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
// @mui/icons-material
import Close from "@mui/icons-material/Close";
// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/modalStyleLoading.js";
import avoblogo from "../../assets/img/AVOB-LOGO-BLANC_small.png";
import "../../assets/css/loadingavob.css";
import ReactLoading from "react-loading";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Modal(props) {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal
        }}
        open={props.open}
        transition={Transition}
        keepMounted
        // onClose={() => setModal(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
        disableBackdropClick = {true}
        disableEscapeKeyDown = {true}
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        
        <DialogContent>
          {/* <div class="animatedbox"> 
          <span></span>
        <span></span>
        <span></span>
        <span></span> */}
          <img src={avoblogo}></img>
          {/* </div> */}
          <ReactLoading
              type={"bars"}
              color={"#91c241"}
              height={"20%"}
              width={"20%"}
              style={{marginLeft: "40%", marginTop:"10px", height:"20%",width:"20%",fill:"#91c241"}}
          />
        </DialogContent>
        
      </Dialog>
    </div>
  );
}